import React from 'react';
import { Image, Link, MarginBox, PUBLIC } from 'UI';

const RenaultGroupLogo = () => {
  return (
    <Link to={'/'}>
      <MarginBox mt={-2}>
        <Image
          type={PUBLIC}
          src={'renault-group-logo-mini.svg'}
          alt={'renault-group-logo-mini'}
          width={32}
          dataCy={'renault-group-logo'}
        />
      </MarginBox>
    </Link>
  );
};

export default RenaultGroupLogo;
